export const MIN_ADULT_AGE = 18;
